export function calculateKeyboardOverlap(containerBottom?: number, keyboardTop?: number, keyboardVisible = false) {
  if (!keyboardVisible || containerBottom === undefined || keyboardTop === undefined) return 0;
  return Math.max(0, Math.round(containerBottom - keyboardTop));
}

export function calculateKeyboardTop(
  keyboardScreenY: number,
  keyboardHeight: number,
  windowHeight: number,
  topInset: number,
  bottomInset: number,
  isAndroid: boolean,
) {
  if (!isAndroid) return keyboardScreenY;

  // React Native subtracts the system-bar inset from the Android keyboard
  // height, while measureInWindow is relative to the app window below the
  // top system inset. Reconstruct the IME top in that same coordinate space.
  return Math.max(0, windowHeight - topInset - keyboardHeight - bottomInset);
}
